// User action Type
export const SET_AUCTION_THEME_LIST = "SET_AUCTION_THEME_LIST";
export const ADD_AUCTION_THEME = "ADD_AUCTION_THEME";
export const EDIT_AUCTION_THEME = "EDIT_AUCTION_THEME";
export const DELETE_AUCTION_THEME = "DELETE_AUCTION_THEME";
